angular.module('licensure.internal')
    .controller('InternalActions', ['$scope', '$uibModal', 'Permissions', function ($scope, $uibModal, Permissions) {
        $scope.getPermission = function (state, variable, method) {
            if (method == null) {
                method = 'view';
            }

            Permissions[method](state).then(function (access) {
                $scope[variable] = access;
            })
        }

        $scope.printInvestigationModal = function () {
            $uibModal.open({
                animation: true,
                templateUrl: paths.app + 'investigations/components/investigation-print/investigation-print.html',
                controller: 'InternalInvestigationPrint',
                size: 'lg',
                resolve: {
                    parameters: $scope.parameters
                }
            }).result.then(function (t) {
                //Handle after the modal is closed.
            })
        }

        $scope.getAge = function (dob) {
            var val = "";

            if (dob != null) {
                var now = new Date(); //Todays Date   

                var dobMonth = dob.getMonth() + 1;  //jan=0 so month+1
                var dobDay = dob.getDate();
                var dobYear = dob.getFullYear();

                var nowDay = now.getDate();
                var nowMonth = now.getMonth() + 1;  //jan=0 so month+1
                var nowYear = now.getFullYear();

                var ageyear = nowYear - dobYear;
                var agemonth = nowMonth - dobMonth;
                var ageday = nowDay - dobDay;
                if (agemonth < 0) {
                    ageyear--;
                    agemonth = (12 + agemonth);
                }
                if (nowDay < dobDay) {
                    agemonth--;
                    ageday = 30 + ageday;
                }
                val = ageyear + " years, " + agemonth + " months";
            }

            return val;
        }
    }])
;